// src/context/WarehouseContext.tsx
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  FC,
  Dispatch,
  SetStateAction
} from 'react';

// Define the warehouse type
interface Warehouse {
  uniqueId: string;
  "werehouse name": string;
  address: string;
  lga: string;
  "warehouse state": string;
}

// Define context type
interface WarehouseContextType {
  selectedWarehouse: Warehouse | null;
  setSelectedWarehouse: Dispatch<SetStateAction<Warehouse | null>>;
  allWarehouses: Warehouse[];
  setAllWarehouses: Dispatch<SetStateAction<Warehouse[]>>;
}

// Create context with explicit type
const WarehouseContext = createContext<WarehouseContextType | undefined>(undefined);

// Provider component with proper typing
export const WarehouseProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState<Warehouse | null>(null);
  const [allWarehouses, setAllWarehouses] = useState<Warehouse[]>([]);

  return (
    <WarehouseContext.Provider
      value={{
        selectedWarehouse,
        setSelectedWarehouse,
        allWarehouses,
        setAllWarehouses
      }}>
      {children}
    </WarehouseContext.Provider>
  );
};

// Custom hook with proper error handling
export const useWarehouse = (): WarehouseContextType => {
  const context = useContext(WarehouseContext);
  if (!context) {
    throw new Error('useWarehouse must be used within a WarehouseProvider');
  }
  return context;
};